import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChaseRequestUID } from '@archinsurance-da/arch-portal-tools';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BondData } from '../interfaces/bond.interface';
import { ChaseTransactionFillData } from '../interfaces/chase.interface';
import { PolicyData, PaymentUsUrl, PaymentUsAddCard, sendEmailUpdate } from '../interfaces/policy.interface';
import { constants } from './../../@shared/constants';

@Injectable({
  providedIn: 'root',
})
export class ChaseService {
  authenticationService: any;
  private readonly productMapping = constants.product_mapping as Record<string, string>;

  constructor(private http: HttpClient) {}

  getPaymentTechUID(
    amount: number,
    transType: string,
    tpfd: ChaseTransactionFillData,
    paymentType: string = 'card',
    lob: string = ''
  ): Observable<any> {
    let payload: ChaseRequestUID = {};
    payload.amount = amount;
    payload.sessionId = `sess_${tpfd.id}`;
    payload.orderId = `pp_${tpfd.id}`;

    console.log('transType', transType);
    if (transType === 'auth' || transType === 'auth_only') {
      payload.cssURL = 'https://arch-test-assets.s3.amazonaws.com/arch-chase-insured-portal-update-card.css';
    } else {
      payload.cssURL = 'https://arch-test-assets.s3.amazonaws.com/arch-chase-billing-portal.css';
    }
    console.log('payload.cssURL', payload.cssURL);

    if (lob) {
      payload.lob = lob;
    }

    payload.callbackURL = environment.chaseCallBackUrl;
    payload.name = tpfd.name ? tpfd.name : '';
    payload.transType = transType; //'auth_only' or 'auth_capture';
    console.log('paymentType', paymentType);
    payload.paymentType = paymentType === 'check' ? 'ECP' : 'Credit_Card';
    // console.log('payload.paymentType', payload.paymentType);

    if (payload.paymentType === 'Credit_Card') {
      payload.collectAddress = '3';
      payload.zip = tpfd.postalCode ? tpfd.postalCode : '';
    } else {
      payload.collectAddress = '0';
    }

    if (payload.paymentType === 'ECP') {
      payload.cssURL = 'https://arch-test-assets.s3.amazonaws.com/arch-chase-billing-portal-echeck.css';
    }
    // payload.address = '';
    // payload.city = '';
    // payload.state = '';

    return this.http.post<any>(environment.billingPortalApiHost + constants.initializePaymentEndPoint, payload).pipe(
      map((uidResult) => {
        return uidResult?.uid || uidResult?.uID;
        // return this.mapMajescoScheduleToPaymentSchedule(scheduleResult);
      })
    );
  }
  getPaymentUsToken(policyStore: any, token: any, method: any): Observable<any> {
    let payload: PaymentUsUrl = {};
    payload.pmCategory = 'CC';
    payload.insuredName = policyStore.policy.addressDto.insuredName;
    payload.ownerId = policyStore.policy?.policyId;
    if (method == false) {
      payload.token = token;
    }
    payload.postMessagePmDetailsOrigin = environment.postMessagePmDetailsOrigin + policyStore.policy?.policyId;
    let apiEndPointURL = environment.billingPortalApiHost;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');

    headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));

    headers = headers.append('Accept', 'application/json');
    // console.log('environment.archConnectHost + environment.paymentScheduleEndpoint', environment.archConnectHost + environment.paymentScheduleEndpoint);
    return this.http.post<any>(apiEndPointURL + constants['initializePaymentUsEndPoint'], payload, { headers }).pipe(
      map((token) => {
        console.log(token.token);
        return token.token;
      })
    );
  }
  addCard(token: string, oldToken: string, paymentPlan: string, policyId: string, product: any): Observable<any> {
    let headers: HttpHeaders = new HttpHeaders();
    let apiEndPointURL = environment.billingPortalApiHost;
    let payload: PaymentUsAddCard = {};
    payload.newToken = token;
    payload.oldToken = oldToken;
    payload.paymentPlanCd = paymentPlan;
    payload.product = this.productMapping[product] || product;
    headers = headers.append('Content-Type', 'application/json');
    //headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));

    headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    headers = headers.append('Accept', 'application/json');

    return this.http
      .post<any>(apiEndPointURL + constants.addCard + `/${policyId}`, payload, {
        headers,
      })
      .pipe(
        map((data) => {
          console.log('dataSuccess', data);
          return data;
        })
      );
  }
  //commenting out reconcilePayment as it is not being used anywhere in the codebase. If needed, it can be uncommented and used in the future.
  // reconcilePayment(token: string, mcid: string): Observable<any> {
  //   let headers: HttpHeaders = new HttpHeaders();
  //   let apiEndPointURL = environment.billingPortalApiHost;
  //   let payload: any = {};
  //   payload.mcid = mcid;
  //   payload.paymentToken = token;

  //   console.log('reconcile payload', payload);
  //   headers = headers.append('Content-Type', 'application/json');
  //   //headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));

  //   headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
  //   headers = headers.append('Accept', 'application/json');

  //   return this.http
  //     .post<any>(apiEndPointURL + constants.reconcilePayment, payload, {
  //       headers,
  //     })
  //     .pipe(
  //       map((data) => {
  //         console.log('dataSuccess', data);
  //         return data;
  //       })
  //     );
  // }
  sendUpdateCardEmail(policy: any, product: any) {
    console.log('token', policy);
    let payload: sendEmailUpdate = {};
    payload.policyId = policy.policy.policyId;
    payload.policyNo = policy.policy.polNbr;
    payload.product = this.productMapping[product] || product;
    let headers: HttpHeaders = new HttpHeaders();
    let apiEndPointURL = environment.billingPortalApiHost;
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    headers = headers.append('Accept', 'application/json');

    return this.http
      .post<any>(apiEndPointURL + constants.sendUpdateCardEmail, payload, {
        headers,
      })
      .pipe(
        map((data) => {
          console.log('dataSuccess', data);
          return data;
        })
      );
  }

  updatePolicyPaymentMethod(uid: string, policyData: PolicyData, product: string): Observable<any> {
    product = this.productMapping[product] || product;

    let payload = {
      policyEffDate: policyData.policy.policyEffectiveDate,
      policyNo: policyData.policy.polNbr,
      product: product,
      policyId: policyData.policy.policyId,
    };

    //updateCard/:UID
    return this.http.post<any>(environment.billingPortalApiHost + constants.updateCardEndPoint + uid, payload).pipe(
      map((uidResult) => {
        return uidResult;
        // return this.mapMajescoScheduleToPaymentSchedule(scheduleResult);
      })
    );
  }

  payBond(uid: string, bondData: BondData): Observable<any> {
    //updateCard/:UID
    return this.http.post<any>(environment.billingPortalApiHost + constants.bondPostPayment + uid, bondData).pipe(
      map((uidResult) => {
        return uidResult;
        // return this.mapMajescoScheduleToPaymentSchedule(scheduleResult);
      })
    );
  }

  // doPostPaymentProcessing(uid: string, policyStore: BillingStore): Observable<any> {

  //   return this.http
  //     .post<any>(environment.billingPortalApiHost + environment.postPaymentEndpoint + `/${uid}`, payload, { headers })
  //     .pipe(
  //       map((uidResult) => {
  //         return uidResult;
  //         // return this.mapMajescoScheduleToPaymentSchedule(scheduleResult);
  //       })
  //     );
  // }
}
